import { api } from "./api";

const CODE_KEY = "rahhal.ref.code";
const CLICKED_KEY = "rahhal.ref.clicked";

// Return (and lazily create) the current user's unique referral code
export function getMyReferralCode() {
  let code = localStorage.getItem(CODE_KEY);
  if (!code) {
    code = "rh_" + Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-4);
    localStorage.setItem(CODE_KEY, code);
  }
  return code;
}

// Append ?ref=<my_code> to a share URL
export function withReferral(url) {
  const code = getMyReferralCode();
  try {
    const u = new URL(url, window.location.origin);
    u.searchParams.set("ref", code);
    return u.toString();
  } catch {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}ref=${code}`;
  }
}

// On page load: if URL has ?ref=<X> and it's not mine, register the click once per session
export async function trackIncomingReferral() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (!ref) return;
  const mine = getMyReferralCode();
  if (ref === mine) return;
  const alreadyClicked = sessionStorage.getItem(CLICKED_KEY);
  if (alreadyClicked === ref) return;
  try {
    await api.post("/referrals/click", { code: ref, landing_url: window.location.href });
    sessionStorage.setItem(CLICKED_KEY, ref);
  } catch (err) { console.warn("referral track failed", err); }
}

export async function fetchMyReferralStats() {
  const code = getMyReferralCode();
  const res = await api.get(`/referrals/${code}/stats`);
  return res.data;
}
